import styled from '@emotion/styled'

export const DashedUl = styled.ul`
  li:before {
    content: "- ";
  }
  li {
    margin-top: 4px;
  }
`
